// import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

const Text = ({ id, text }) => {
    const intl = useIntl();
    return intl.formatMessage({ id, defaultMessage: text }).toUpperCase();
};

Text.propTypes = {
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

export default Text;
